import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function notificationReducer(
  state = initialState.notifications,
  action
) {
  switch (action.type) {
    case types.LOAD_NOTIFICATIONS_SUCCESS:
      return action.notifications;
    case types.SAVE_NOTIFICATIONS_OPTIMISTIC:
      return state.map((notification) =>
        notification.notificationID === action.notification.notificationID
          ? action.notification
          : notification
      );
    case types.DELETE_NOTIFICATIONS_OPTIMISTIC:
      return state.filter(
        (notification) =>
          notification.notificationID !== action.notification.notificationID
      );
    case types.DELETE_NOTIFICATIONS_LAST_OPTIMISTIC:
      return action.notification;
    default:
      return state;
  }
}
